var withErrors = false;
function getInventory(item, fn){
  $("body").addClass("loading");
  console.log("sku q:", item.sku);
  $.ajax({
    url: "https://shopibus.gomonke.com/api/Inventory/GetInventoryDistritech/distritechwholesale.myshopify.com/"+encodeURIComponent(item.sku),
    type: "GET",
    success: function (data) {
      $("body").removeClass("loading");
      console.log("inventory data");
      console.log(data);
      fn(item,data);

    },
    error: function (msg) {
      console.log(msg);
      $("body").removeClass("loading");
    }
  });
}

function getPrice(item, fn){
  $("body").addClass("loading");
  $.ajax({
    url: "https://shopibus.gomonke.com/api/Price/GetPriceDistritech/distritechwholesale.myshopify.com/"+encodeURIComponent(item.sku),
    type: "GET",
    success: function (data) {
      $("body").removeClass("loading");
      fn(item,data);
    },
    error: function (msg) {
      console.log(msg);
      $("body").removeClass("loading");
    }
  });

}

function GetInventories(){
  jQuery.getJSON('/cart.js', function(cart) {
    for(var i = 0; i< cart.items.length; i++){
      var item = cart.items[i];
      getInventory(item,validateInventory);
    }
  });
}

function GetPrices(){
  jQuery.getJSON('/cart.js', function(cart) {
    for(var i = 0; i< cart.items.length; i++){
      var item = cart.items[i];
      item.line = i+1;
      getPrice(item,validatePrice);
    }
  });
}

function validateInventory(item, data){
  var inventory  = null;

  try{
    //data = JSON.parse(data);
    inventory = data[0];
  }
  catch{
    }
    console.log(inventory);  

  if(inventory != null){
    var available = parseInt(inventory.cantidad);

    if(item.quantity > available){
      $("#title_"+item.id).css('color', 'red');
      withErrors = true;
        $("body").addClass("loading");
      
      setTimeout(function(){
          $("body").addClass("loading");
        Swal.fire({
          title: 'Actualizar cantidad',
          text: item.product_title+ ", No hay inventario suficiente, la catidad se actualizara de lo contrario se eliminara",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, actualizar!',
          cancelButtonText: 'No, eliminar'
        }).then((result) => {
          if (result.isConfirmed) {
            jQuery.post('/cart/change.js', { quantity: available, id: item.id });
            $("#title_"+item.id).css('color', '#333');
            setTimeout(function(){
              window.location.reload();
            },5000);

          }else{
            jQuery.post('/cart/change.js', { quantity: 0, id: item.id });
            $("#title_"+item.id).css('color', '#333');
            setTimeout(function(){
              window.location.reload();
            },5000);
          }
        })

      },500);
    }
  }
}

function validatePrice(item, data){
  var price  = null;

  try{
    data = JSON.parse(data);
    price = data.value[0];
  }
  catch{
    }
    console.log(price);  

  if(price != null){
    var priceList1 = parseFloat(price.Price);
    var priceList2 = parseFloat(price.Price2);
    var priceList3 = parseFloat(price.Price3);
    var priceList4 = parseFloat(price.Price4);
    //var priceWithDiscount = getPriceInRange(item.properties._unitsRange, item.quantity, item.price, priceList1, priceList2, priceList3, priceList4 );
    var priceWithDiscount = getPriceInRange(item.properties._unitsRange, item.quantity, item.price, priceList4, priceList4, priceList4, priceList4 );

    if(priceWithDiscount != parseFloat(item.properties._priceWithDiscount)){
      $("#title_"+item.id).css('color', 'red');
      withErrors = true;
 $("body").addClass("loading");
      setTimeout(function(){
        Swal.fire({
          title: 'Actualizar precio',
          text: item.product_title+ ", El precio cambio, se actualizara de lo contrario se eliminara",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, actualizar!',
          cancelButtonText: 'No, eliminar'
        }).then((result) => {
          if (result.isConfirmed) {
            item.properties._priceWithDiscount = priceWithDiscount+"";
            jQuery.post('/cart/change.js', { properties :  item.properties, line: item.line, quantity: item.quantity });
            $("#title_"+item.id).css('color', '#333');
            setTimeout(function(){
              window.location.reload();
            },5000);

          }else{
            jQuery.post('/cart/change.js', { quantity: 0, id: item.id });
            $("#title_"+item.id).css('color', '#333');
            setTimeout(function(){
              window.location.reload();
            },5000);
          }
        });
      },500);
    }
  }
}

function getPriceInRange(unitsRange, quantity, currentPrice, priceRange1,priceRange2, priceRange3, priceRange4){
  var priceWithDiscount = currentPrice;

  console.log(quantity);  
  console.log(unitsRange);  

  if(unitsRange == null || unitsRange == ""){
    if(quantity > 0 && priceRange1 >  0){
      priceWithDiscount = priceRange1*100;
    }
    if(quantity > 49 && priceRange2 >  0){
      priceWithDiscount = priceRange2*100;
    }
    if(quantity > 99 && priceRange3 >  0){
      priceWithDiscount = priceRange3*100;
    }
    if(quantity > 499 && priceRange4 >  0){
      priceWithDiscount = priceRange4*100;
    }
  }
  else{
    try {
      var ranges = unitsRange.split("/");

      for(var i =0; i<ranges.length; i++){
        let item = ranges[i];
        var basePrice = item.split(":")[0];        
        var qtyRanges = item.split(":")[1].split(",");

        if(parseFloat(currentPrice)/100 > parseFloat(basePrice)){
          if(quantity >= parseInt(qtyRanges[0]) && priceRange1 >  0){
            priceWithDiscount = priceRange1*100;
          }
          if(quantity >= parseInt(qtyRanges[1]) && priceRange2 >  0){
            priceWithDiscount = priceRange2*100;
          }
          if(quantity >=  parseInt(qtyRanges[2]) && priceRange3 >  0){
            priceWithDiscount = priceRange3*100;
          }
          if(quantity >=  parseInt(qtyRanges[3]) && priceRange4 >  0){
            priceWithDiscount = priceRange4*100;
          }
        }
      }

    } catch (error) {
      console.error(error);
    }
  }
  console.log(priceWithDiscount);

  return priceWithDiscount;
}

function changeInputQuantity(inputQty, id){
  var qty = parseInt(inputQty);
  adjustPrice(qty,id);
}


function suscribechangeInputQuantity(){

  jQuery.getJSON('/cart.js', function(cart) {
    for(var i = 0; i< cart.items.length; i++){
      var item = cart.items[i];
      const qtyInput = document.getElementById('updates_'+item.key);

      qtyInput.addEventListener('change', (event) => {
        console.log(event);

        var input =  document.getElementById(event.target.id);
        var qtyField = input.closest(".qtyField");
        var qty = parseInt(input.value);

        changeInputQuantity(qty, qtyField.id);
      });
    }
  });
}